/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { DonationResultStatus } from 'src/types/api'

type Props = {
  status: DonationResultStatus
}

const HistoryDetail = ({ status }: Props) => {
  return null
}

export default HistoryDetail
